import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import BrentHaus from "@/pages/BrentHaus";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<BrentHaus />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
